var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionLockOpenOutlineOpt2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 8h9V6c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0012 3c-.833 0-1.542.292-2.125.875a3.38 3.38 0 00-.104.108L8.358 2.57l.105-.108C9.438 1.487 10.617 1 12 1s2.563.487 3.538 1.462C16.513 3.437 17 4.617 17 6v2h1c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v10a1.93 1.93 0 01-.587 1.413A1.928 1.928 0 0118 22H6c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 014 20V10c0-.55.196-1.021.588-1.413A1.925 1.925 0 016 8zm0 12h12V10H6v10zm6-3a1.93 1.93 0 001.413-.587c.391-.392.587-.863.587-1.413s-.196-1.021-.587-1.413A1.928 1.928 0 0012 13c-.55 0-1.02.196-1.412.587A1.927 1.927 0 0010 15c0 .55.196 1.021.588 1.413.391.391.862.587 1.412.587z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionLockOpenOutlineOpt2);
export default __webpack_public_path__ + "3e5cd35ae037e7bf5aad2da0ca3f4712.svg";
export { ForwardRef as ReactComponent };